export default "__VITE_ASSET__DxQLlo19__"